// Import: Middleware Action & Custom Types
import {
  CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT,
  CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR,
} from '_models/redux/types';

// Action function
export const cleanOrderAssignmentCreateUrlDocument = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR,
    });
  }
};
